import { render, staticRenderFns } from "./editFloorShare.vue?vue&type=template&id=64a53120&scoped=true"
import script from "./editFloorShare.vue?vue&type=script&lang=js"
export * from "./editFloorShare.vue?vue&type=script&lang=js"
import style0 from "./editFloorShare.vue?vue&type=style&index=0&id=64a53120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a53120",
  null
  
)

export default component.exports